<template>
    <div v-show="isLoad" class="easyui-layout body-box">
        <div class="left-box">
            <img alt class="logo-box" src=""/>
        </div>
        <div class="right-box flex-center">
            <div class="login-border">
                <div class="login-switch">
                    <div class="login-tab" @click="switchLoginMethod" @mouseout="showLoginPrompt = false"
                         @mouseover="showLoginPrompt = true">
                         <el-tooltip popper-class="custom-tooltip"  :content="$t('nailNailLogin')" placement="left">
                            <img v-show="accountLogin" alt src="~@/assets/images/erweima.png"/>
                        </el-tooltip>
                        <el-tooltip popper-class="custom-tooltip"  :content="$t('ytoAccountLogin')" placement="left">
                            <img v-show="!accountLogin" alt src="~@/assets/images/zhanghao.png"/>
                        </el-tooltip>
                    </div>
                    <div v-show="showLoginPrompt" class="scavenging">
                    </div>
                </div>
                <div class="login-title flex-center">
                    <img alt class="logo-box" src="~@/assets/images/login_logo.png"/>
                    <span style="margin-left: 16px;float: left;">{{ $t('ytoGlobal.title') }}</span>
                </div>
                <div class="login-info flex-center">
                    <div class="lang-box">
                        <div class="cur-lang" @mouseout="langShow = false" @mouseover="langShow = true">
                            <em :class="currentLang.value"></em>
                            <span style="cursor: pointer;">{{ currentLang.name }}</span>
                            <i class="icon-triangle"></i>
                        </div>
                        <ul v-show="langShow" id="selLanguage" class="lang-list" @mouseout="langShow = false"
                            @mouseover="langShow = true">
                            <li v-for="(item, index) in this.language" :key="item.value"
                                v-bind:class="{ active:index==currentLang.index}" @click="setLanguage(index)"><em
                                :class="item.value"></em>
                                {{ item.name }}
                            </li>
                        </ul>
                    </div>
                    <div v-show="accountLogin" class="tab-content">
                        <el-form ref="loginForm" :model="loginForm" class="loginForm" label-width="0px" status-icon>
                            <el-form-item prop="userName">
                                <el-input ref="userName" v-model="loginForm.userName" :placeholder="$t('ytoUserName')" clearable></el-input>
                            </el-form-item>
                            <el-form-item prop="password">
                                <el-input ref="password" v-model="loginForm.password" type="password" :placeholder="$t('ytoPassword')" clearable></el-input>
                            </el-form-item>
                            <el-form-item prop="verifyCode" class="verifyCode_item" style="display: flex; align-items: center;">
                                <el-input ref="verifyCode" v-model="loginForm.verifyCode" maxlength="4"
                                          style="width: 200px" type="verifyCode" @input="checkCaptcha"
                                          @keyup.enter.native="passWordLogin" :placeholder="$t('ytoVerifyCode')" clearable></el-input>
                                <img :src="captchaUrl" class="verifyCode-img" @click="clickCaptcha"
                                     @error="loadErrorCaptcha"/>
                                <div class="verifyCode-right-icon">
                                    <img v-show="captchaFlagOk" src="~@/assets/images/icon-verifyCode-ok.png">
                                    <img v-show="captchaFlagErr" src="~@/assets/images/icon-verifyCode-err.png">
                                </div>
                                <span style="margin-top: 4px;" class="clickCaptcha_btn">
                                    <i class="el-icon-refresh-right rotate-icon" @click="clickCaptcha" @mousedown="startRotation" @mouseup="stopRotation"></i>
                                </span>
                            </el-form-item>
                            <div class="commit-box com-btn" @click="passWordLogin()">{{ $t('button_login') }}</div>
                        </el-form>
                    </div>
                    <div v-show="!accountLogin" class="tab-content">
                        <div id="dingTalk-qrcode" class="dingTalk-qrcode"></div>
                    </div>
                    <div class="chrome-link">
                        <a v-show="isChrome" :title="$t('downloadBrowserTitle')" download="推荐谷歌浏览器.zip"
                           href="https://static.yto56.com.cn/static/chrome/推荐谷歌浏览器.zip"
                           target="_blank">{{ $t('downloadBrowser') }}</a></div>
                </div>
            </div>
        </div>
        <!-- 添加迁移公告组件 -->
        <migration-notice-dialog v-if="$i18n.locale === 'zh_CN'"  ref="migrationNoticeDialog" />
        <MigrationNoticeDialogUS v-else ref="migrationNoticeDialog" />
    </div>
</template>

<script>
import MigrationNoticeDialog from './components/MigrationNoticeDialog.vue';
import MigrationNoticeDialogUS from './components/MigrationNoticeDialogUS.vue';

export default {
    name: 'login',
    components: {
        MigrationNoticeDialog,
        MigrationNoticeDialogUS
    },
    data() {
        return {
            isLoad: false,
            showLoginPrompt: false,
            accountLogin: localStorage.getItem('accountLogin') == 'true' ? true : false,
            loginForm: {
                userName: '',
                password: '',
                verifyCode: ''
            },
            langShow: false,
            currentLang: {
                value: '',
                name: '',
                index: ''
            },
            isLoading: false, // 控制loading状态的变量
            captchaUrl: '',
            captchaFlagOk: false,
            captchaFlagErr: false,
            isChrome: !/.*(chrome)\/([\w.]+).*/.test(navigator.userAgent.toLowerCase()),
            language: language,
            // language: '',
            timer: '',
        }
    },
    beforeCreate() {
        //判断是否在iframe中
        if (self != top) {
            parent.window.location.replace(window.location.href);
        }
        if (document.location.protocol == 'http:') {
            window.location = 'https://' + window.location.host;
        }
    },
    mounted() {
        console.log('this.$i18n.locale', this.$i18n.locale)
        this.$refs.migrationNoticeDialog.show();
        //设置默认选择语言
        this.setLanguage(localStorage.getItem('langIndex') == null ? 0 : localStorage.getItem('langIndex'));
        this.checkIsLogin();
        if (this.accountLogin) {
            this.clickCaptcha();
        } else {
            this.ddLogin();
        }
        this.language = this.language.filter(item => item.value !== "vi_VN");
    },
    methods: {
        checkIsLogin() {
            let vm = this;
            this.$http({
                headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'},
                method: 'post',
                url: '/yto-portal/login/isLogin.do',
            }).then(function ({data}) {
                if (data.success === true) {
                    window.location = "/yto-portal/index/index.do";
                } else {
                    vm.isLoad = true;
                }
            }).catch(function () {
                vm.isLoad = true;
            });
        },
        startRotation(event) {
            // 开始旋转动画
            setTimeout(() => {
                event.target.classList.add('rotate-90');
            }, 150);
        },
        stopRotation() {
            // 停止旋转动画
            const icon = this.$el.querySelector('.el-icon-refresh-right');
            icon.classList.remove('rotate-90');
            icon.classList.add('rotate-back');

            // 延迟移除rotate-back类，以便用户看到图标停止旋转
            setTimeout(() => {
                icon.classList.remove('rotate-back');
            }, 200); // 假设旋转动画需要500毫秒完成
        },
        setLanguage(index) {
            this.langShow = false;
            this.currentLang = this.language[index];
            this.$i18n.locale = this.currentLang.value;
            localStorage.setItem('langIndex', this.currentLang.index);
        },
        switchLoginMethod() {
            this.accountLogin = !this.accountLogin;
            if (this.accountLogin) {
                this.clickCaptcha();
            } else {
                this.ddLogin();
            }
            localStorage.setItem('accountLogin', this.accountLogin);
        },
        loadErrorCaptcha() {
            this.captchaUrl = require('../../assets/images/default-verifyCode.png');
        },
        clickCaptcha(event) {
            this.captchaFlagOk = false;
            this.captchaFlagErr = false;
            this.loginForm.verifyCode = '';
            this.captchaUrl = '/yto-portal/portal/jwt/auth/verify/create.do?d=' + new Date() * 1;
        },
        checkCaptcha() {
            this.captchaFlagOk = this.captchaFlagErr = false;
            let vm = this;
            if (vm.loginForm.verifyCode.length >= 4) {
                this.$http({
                    headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'},
                    method: 'post',
                    url: '/yto-portal/portal/jwt/auth/verify/check.do',
                    params: {
                        verifyCode: vm.loginForm.verifyCode
                    }
                }).then(function ({data}) {
                    if (data.success) {
                        vm.captchaFlagOk = true;
                    } else {
                        if (data.code === 'VERIFY_CODE_EXPIRED') {
                            vm.clickCaptcha();
                            vm.$alert(vm.$t(data.message), vm.$t('el.messagebox.title'), {
                                confirmButtonText: vm.$t('el.colorpicker.confirm'),
                                type: 'error'
                            });
                            vm.$refs.verifyCode.focus();
                        } else {
                            vm.captchaFlagErr = true;
                        }
                    }
                }).catch(function () {
                    console.log("Failed to get verification code");
                });
            }
        },
        passWordLogin() {
            let jsEncrypt = new JSEncrypt();
            jsEncrypt.setPublicKey(this.$store.state.publicKey);
            let loading = this.$loading({
                lock: true,
                text: this.$t('loginLoading'),
                spinner: 'el-icon-loading',
                background: 'rgba(255, 255, 255, 1)'
            });
            let vm = this;
            this.$http({
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                method: 'post',
                url: '/yto-portal/portal/auth/login/password',
                params: {
                    userName: vm.loginForm.userName,
                    password: jsEncrypt.encrypt(vm.loginForm.password),
                    verifyCode: vm.loginForm.verifyCode
                }
            }).then(function ({data}) {
                if (data.success === true) {
                    localStorage.setItem('loginMethod', JSON.stringify('密码登录'));
                    window.location = '/yto-portal/index/index.do';
                } else {
                    loading.close();
                    vm.loginForm.verifyCode = '';
                    vm.captchaUrl = '/yto-portal/portal/jwt/auth/verify/create.do?d=' + new Date() * 1;
                    vm.captchaFlagOk = vm.captchaFlagErr = false;
                    vm.$alert(vm.$t(data.code), vm.$t('el.messagebox.title'), {
                        confirmButtonText: vm.$t('el.colorpicker.confirm'),
                        type: 'error'
                    });
                    //光标到移动到指定的框
                    if (data.code === "VERIFY_CODE_FALSE" || data.code === "VERIFY_CODE_NULL" || data.code === "VERIFY_CODE_EXPIRED") {
                        vm.$refs.verifyCode.focus();
                    } else if (data.code === "CREDENTIAL_PASSWORD_FALSE") {
                        vm.$refs.password.focus();
                    } else {
                        vm.$refs.userName.focus();
                    }
                }
            }).catch(function (e) {
                console.error(e);
                loading.close();
                vm.captchaFlagOk = vm.captchaFlagErr = false;
                vm.$alert(vm.$t("CREDENTIAL_PASSWORD_FALSE"), vm.$t('el.messagebox.title'), {
                    confirmButtonText: vm.$t('el.colorpicker.confirm'),
                    type: 'error'
                });
            });
        },
        ddLogin() {
            let vm = this;
            DingTalkLogin({
                id: "dingTalk-qrcode",
                goto: vm.$store.getters.getGoto,
                style: "border:none;background-color:#FFFFFF;",
                width: "230px",
                height: "300px"
            });
            let ddHandleMessage = function (event) {
                if (event.origin == "https://login.dingtalk.com") {
                    window.location.href = vm.$store.getters.getAuthorizeUrl + event.data;
                }
            };
            if (typeof window.addEventListener != 'undefined') {
                window.addEventListener('message', ddHandleMessage, false);
            } else if (typeof window.attachEvent != 'undefined') {
                window.attachEvent('onmessage', ddHandleMessage);
            }
        }
    },
}

</script>

<style lang="css" scoped>

.body-box {
    display: flex;
    height: 100%;
    font-size: 14px;
    background: #EFEEEF;
}

/* left */
@media (max-width: 800px) {
    .left-box {
        display: none;
    }
}

.left-box {
    position: relative;
    flex: 70%;
    height: 100%;
    background: url("~@/assets/images/bg_login.png") center center;
    background-size: auto 110%;
    background-repeat: no-repeat;
    background-color: #EFEEEF;
}

.left-box img {
    position: absolute;
    left: 66px;
    top: 34px;
    height: 55px;
}

.right-box {
    flex: 30%;
    flex-flow: wrap column;
}

.login-border {
    height: 500px;
    position: relative;
    padding: 65px 65px 0 65px;
    margin: auto 10px;
    background: #FFFFFF;
}

.login-border .login-tab {
    float: right;
    cursor: pointer;
}

.login-border .login-tab img {
    width: 53px;
}

.login-switch {
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
}

.scavenging {
    float: right;
    margin-top: 4px;
    margin-right: -7px;
}

.scavenging img {
    width: 73px;
}

.login-title {
    width: 320px;
    font-size: 24px;
    font-weight: 500;
    height: 60px;
    margin: auto;
    color: #000;
}

.login-title img {
    width: 60px;
    height: 60px;
}

.flex-center {
    justify-content: center;
    align-items: center;
    display: flex;
}

.label-con {
    display: block;
    width: 100%;
    text-align: left;
    color: #909399;
    height: 32px;
}

.login-info {
    flex-flow: wrap column;
    margin: auto;
}

.tab-content {
    position: relative;
}

.commit-box {
    cursor: pointer;
    margin-bottom: 12px;
}

.loginForm {
    margin-top: 30px;
}

input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0 1000px white inset;
}

.com-btn {
    height: 36px;
    line-height: 36px;
    color: #fff;
    font-size: 16px;
    border-radius: 3px;
    width: 324px;
    background: #762ADB;
    border: none;
    outline: none;
    margin-top: 30px;
}

/* qrcode */
.tab-content {
    margin-top: 20px;
}

.dingTalk-qrcode {
    padding: 0px 39px 65px 39px;
}

/* language */
.lang-box {
    width: 130px;
    display: flex;
    justify-content: flex-end;
    position: relative;
    cursor: pointer;
    margin-top: 20px;
    margin-left: 180px;
}

.cur-lang {
    display: flex;
    align-items: center;
    cursor: pointer;
    height: 25px;
    position: relative;
    padding-right: 16px;
    padding-bottom: 6px;
    line-height: 25px;
}

.cur-lang em {
    display: block;
    width: 24px;
    height: 14px;
    margin-right: 12px;
}

em.zh_CN,
em.zh_TW {
    background: url("~@/assets/images/icon-china.png");
    background-size: 24px 14px;
}

em.en_US {
    background: url("~@/assets/images/icon-usa.png");
    background-size: 24px 14px;
}

em.ko_KR {
    background: url("~@/assets/images/icon-korea.png");
    background-size: 24px 14px;
}

em.vi_VN {
    background: url("~@/assets/images/icon-vietnam.png");
    background-size: 24px 14px;
}

.cur-lang span {
    color: #909399;
}

.cur-lang .icon-triangle {
    position: absolute;
    right: 0;
    top: 10px;
    width: 0;
    height: 0;
    border-top: 6px solid #909399;
    border-right: 4px solid transparent;
    border-left: 4px solid transparent;
}

.lang-list {
    border: solid 1px #e8e8e8;
    position: absolute;
    top: 25px;
    right: -1%;
    background: #fff;
    z-index: 3;
}

.lang-list li {
    height: 34px;
    line-height: 34px;
    padding: 0 14px;
    color: #222;
    text-align: left;
    cursor: pointer;
    list-style-type: none;
}

.lang-list li:hover {
    background: #762adb;
    color: #fff;
}

.lang-list .active {
    background: #762adb;
    color: #fff;
}

.lang-list li em {
    display: inline-block;
    width: 24px;
    height: 14px;
    margin-right: 10px;
}

.verifyCode-img {
    /* vertical-align: auto; */
    /* float: right; */
    cursor: pointer;
    width: 82px;
    height: 40px;
    margin: 0 10px;
    display: table-cell; /* 将子元素设为表格单元格 */
    vertical-align: middle; /* 垂直居中 */
    text-align: center; /* 水平居中 */
}

.verifyCode-right-icon {
    width: 24px;
    height: 24px;
    position: absolute;
    left: 320px;
    margin-top: 8px;
    margin-left: 10px;
}

.chrome-link {
    height: 36.5px;
}

.chrome-link a {
    display: inline-block;
    font-size: 12px;
    color: #7D8790;
    padding: 5px;
    text-decoration: none;
    margin-bottom: 30px;
}

.chrome-link a:hover {
    color: #762ADB;
}

.el-loading-spinner i {
    color: #762ADB !important;
}

.el-loading-spinner .el-loading-text {
    color: #762ADB !important;
}
.refresh-btn {
  display: inline-block;
  position: relative;
  cursor: pointer;
}

.el-icon-refresh-right {
  transition: transform 1s ease;
}
.rotate-back {
  transform: none; /* 确保图标在动画完成后回到初始状态 */
}
@keyframes rotate-90 {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg); /* 旋转90度 */
  }
}
.el-icon-refresh-right {
  /* font-weight: 700; */
  display: inline-block;
  transition: transform 1s ease; /* 平滑过渡效果 */
}
.rotate-90 {
    animation: rotate-90 1s forwards; /* 动画持续时间和结束状态 */
}
:deep(.el-input__inner) {
     box-shadow: 0 0 0 1000px #fff inset;
 }
</style>
<!-- 新增：非 scoped 全局样式，确保对 body 挂载的弹框生效 -->
<style lang="css">
/* 确保所有弹框居中 */
.el-dialog__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.el-dialog__wrapper .el-dialog {
  margin: 0 auto !important;
  position: relative;
  top: 0;
  transform: none;
}
</style>